/**
 * Keeps the sticky product gallery column's box as tall as the info column
 * next to it (accordions, FAQ, etc.), so the sticky image never runs out of
 * room early and exposes blank space below it.
 *
 * This can't be done with flex `align-items: stretch` alone: when the info
 * column's height changes (e.g. an accordion opening), a flex-stretched
 * sibling's height snaps to the new value in a single reflow rather than
 * animating, which yanks the sticky image to a new position mid-scroll.
 * Driving the gallery's height explicitly via an inline `min-height` lets the
 * `transition: min-height` in styles.css.liquid animate it smoothly instead.
 */
(() => {
  'use strict';

  const DESKTOP_QUERY = '(min-width: 1040px)';

  function setupContainer(productDetail) {
    const gallery = productDetail.querySelector(
      ':scope > .gallery.product-column-left'
    );
    const info = productDetail.querySelector(
      ':scope > .detail.product-column-right'
    );
    if (!gallery || !info) return;

    let resizeObserver = null;

    function sync() {
      gallery.style.minHeight = info.getBoundingClientRect().height + 'px';
    }

    function enable() {
      if (resizeObserver) return;
      sync();
      resizeObserver = new ResizeObserver(sync);
      resizeObserver.observe(info);
    }

    function disable() {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      gallery.style.minHeight = '';
    }

    const mq = window.matchMedia(DESKTOP_QUERY);
    if (mq.matches) enable();

    const handleChange = (e) => (e.matches ? enable() : disable());
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handleChange);
    } else if (typeof mq.addListener === 'function') {
      // Safari < 14
      mq.addListener(handleChange);
    }
  }

  function init() {
    document.querySelectorAll('.product-detail').forEach(setupContainer);
  }

  if (typeof ResizeObserver === 'undefined') return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
